import { render, staticRenderFns } from "./SocialEngagement.vue?vue&type=template&id=3a2a4b32&scoped=true"
import script from "./SocialEngagement.vue?vue&type=script&lang=js"
export * from "./SocialEngagement.vue?vue&type=script&lang=js"
import style0 from "./SocialEngagement.vue?vue&type=style&index=0&id=3a2a4b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2a4b32",
  null
  
)

export default component.exports